import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Registro from "@/pages/Registro";
import Legal from "@/pages/Legal";
import Proximamente from "@/pages/Proximamente";
import Contacto from "@/pages/Contacto";
import Resultados from "@/pages/Resultados";
import Tramite from "@/pages/Tramite";
import MisTramites from "@/pages/MisTramites";
import Reingreso from "@/pages/Reingreso";
import StaffApp from "@/pages/staff/StaffApp";
import CookieBanner from "@/components/CookieBanner";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function ConditionalCookieBanner() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/staff")) return null;
  return <CookieBanner />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/resultados" element={<Resultados />} />
          <Route path="/mis-tramites" element={<MisTramites />} />
          <Route path="/tramite/:id" element={<Tramite />} />
          <Route path="/tramite" element={<MisTramites />} />
          <Route path="/reingreso" element={<Reingreso />} />
          <Route path="/staff/*" element={<StaffApp />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/proximamente" element={<Proximamente />} />
        </Routes>
        <ConditionalCookieBanner />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
